(function () {
  const KEY_PREFIX = 'chagual-wa-seen:';
  const META_UTM_SOURCES = ['meta', 'facebook', 'instagram'];

  function normalizeUtmSource(value) {
    return String(value || '').trim().toLowerCase();
  }

  function isMetaSource(search) {
    if (typeof URLSearchParams !== 'function') return false;

    try {
      var params = new URLSearchParams(search || '');
      return META_UTM_SOURCES.indexOf(normalizeUtmSource(params.get('utm_source'))) !== -1;
    } catch (e) {
      return false;
    }
  }

  function buildControlledMessage(greeting, canonicalUrl, search) {
    var lines = [String(greeting || '').trim(), 'Página: ' + String(canonicalUrl || '').trim()];
    if (isMetaSource(search)) lines.push('Origen: Meta');
    return lines.join('\n');
  }

  function syncWhatsappHref(wa) {
    if (!wa) return '';

    var number = wa.dataset.waNumber || '';
    var message = buildControlledMessage(
      wa.dataset.waGreeting,
      wa.dataset.waCanonicalUrl,
      window.location ? window.location.search : ''
    );
    var href = 'https://wa.me/' + number + '?text=' + encodeURIComponent(message);
    wa.setAttribute('href', href);
    return href;
  }

  function syncContextualWhatsappLinks() {
    var links = document.querySelectorAll('[data-chagual-wa-context-link]');
    Array.prototype.forEach.call(links, syncWhatsappHref);
  }

  function computeOverlay() {
    const vh = window.innerHeight || document.documentElement.clientHeight;
    let overlay = 0;

    const sticky = document.getElementById('chagualBarSticky');
    if (sticky && sticky.classList.contains('is-active')) {
      const r = sticky.getBoundingClientRect();
      const touchesBottom = r.bottom >= vh - 1 && r.top < vh;
      if (touchesBottom) overlay = Math.ceil(r.height);
    }

    document.documentElement.style.setProperty('--chagual-wa-bottom-overlay', overlay + 'px');
  }

  function isCompactMobile() {
    return typeof window.matchMedia === 'function' &&
      window.matchMedia('(max-width: 767px)').matches;
  }

  function getFooter() {
    return document.querySelector('.shopify-section--footer footer.footer, footer.footer, .shopify-section--footer');
  }

  function syncHiddenByFooter(wa) {
    if (!wa) return false;

    var shouldHide = false;
    if (isCompactMobile()) {
      var footer = getFooter();
      if (footer) {
        var rect = footer.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight || 0;
        shouldHide = rect.top < vh && rect.bottom > 0;
      }
    }

    wa.classList.toggle('is-hidden-by-footer', shouldHide);
    return shouldHide;
  }

  function observeFooterHiddenState(wa) {
    if (!wa || wa.dataset.waFooterObserver === 'true') return;
    var footer = getFooter();
    if (!footer || typeof IntersectionObserver !== 'function') return;

    wa.dataset.waFooterObserver = 'true';
    var observer = new IntersectionObserver(function () {
      syncHiddenByFooter(wa);
      syncHiddenBySticky(wa);
    });
    observer.observe(footer);
  }

  function emitWaEvent(name, detail) {
    if (typeof window.CustomEvent === 'function') {
      document.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
      return;
    }
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(name, false, false, detail || {});
    document.dispatchEvent(evt);
  }

  function setFabPointerEvents(wa, mode) {
    if (!wa) return;

    const button = wa.querySelector('.chagual-wa-fab__button');
    const bubble = wa.querySelector('[data-wa-bubble]');
    const isExpanded = wa.classList.contains('is-expanded');
    const allowVisibleTargets = mode === 'visible';

    wa.style.pointerEvents = 'none';

    if (button) {
      button.style.pointerEvents = allowVisibleTargets ? 'auto' : 'none';
    }

    if (bubble) {
      bubble.style.pointerEvents = allowVisibleTargets && isExpanded ? 'auto' : 'none';
    }
  }

  function syncHiddenBySticky(wa) {
    if (!wa) return false;
    const isHidden = wa.classList.contains('is-hidden-by-sticky') ||
      wa.classList.contains('is-hidden-by-footer');

    if (isHidden) {
      wa.hidden = true;
      wa.setAttribute('aria-hidden', 'true');
      wa.setAttribute('tabindex', '-1');
      setFabPointerEvents(wa, 'hidden');
      return true;
    }

    wa.hidden = false;
    wa.removeAttribute('aria-hidden');
    wa.removeAttribute('tabindex');
    setFabPointerEvents(wa, 'visible');
    return false;
  }

  function observeStickyHiddenState(wa) {
    if (!wa || wa.dataset.waHiddenObserver === 'true') return;
    wa.dataset.waHiddenObserver = 'true';
    syncHiddenBySticky(wa);

    if (typeof MutationObserver !== 'function') return;

    const observer = new MutationObserver(function () {
      syncHiddenBySticky(wa);
    });

    observer.observe(wa, { attributes: true, attributeFilter: ['class'] });
  }

  function bindWhatsapp(wa) {
    if (!wa || wa.dataset.waReady === 'true') return;
    wa.dataset.waReady = 'true';
    syncWhatsappHref(wa);
    observeStickyHiddenState(wa);
    observeFooterHiddenState(wa);

    const bubble = wa.querySelector('[data-wa-bubble]');
    const baseThreshold = parseInt(wa.dataset.waThreshold || '320', 10);
    const path = wa.dataset.waPath || window.location.pathname || 'global';
    const storageKey = KEY_PREFIX + path;
    let expandedOnce = false;
    let collapseTimer = 0;
    let raf = 0;
    let lastScrollY = window.pageYOffset || window.scrollY || 0;
    let scrollDirection = 'up';
    let isScrollSettling = false;
    let settleTimer = 0;

    function getSaleSupportRow() {
      return document.querySelector('[data-sale-plp-root] .chagual-sale-support-row');
    }

    function getSaleProductList() {
      return document.querySelector('[data-sale-plp-root] [data-product-list]');
    }

    function isSaleSupportVisible() {
      const saleSupportRow = getSaleSupportRow();
      if (!saleSupportRow) return false;
      const rect = saleSupportRow.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight || 0;
      return rect.bottom > 0 && rect.top < Math.min(vh, 420);
    }

    function currentThreshold() {
      const scrollTop = window.pageYOffset || window.scrollY || 0;
      const saleSupportRow = getSaleSupportRow();
      const productList = getSaleProductList();
      let threshold = baseThreshold;

      if (saleSupportRow) {
        const rect = saleSupportRow.getBoundingClientRect();
        const absoluteBottom = rect.bottom + scrollTop;
        threshold = Math.max(threshold, Math.round(absoluteBottom + 56));
      }

      if (productList) {
        const rect = productList.getBoundingClientRect();
        const absoluteTop = rect.top + scrollTop;
        threshold = Math.max(threshold, Math.round(absoluteTop + 16));
      }

      return threshold;
    }

    function collapseBubble() {
      wa.classList.remove('is-expanded');
      wa.classList.add('is-collapsed');
      syncHiddenBySticky(wa);
      if (collapseTimer) {
        window.clearTimeout(collapseTimer);
        collapseTimer = 0;
      }
    }

    function expandBubble() {
      if (isCompactMobile()) {
        collapseBubble();
        return;
      }
      if (!bubble || expandedOnce || syncHiddenBySticky(wa)) return;
      expandedOnce = true;
      wa.classList.add('is-expanded');
      wa.classList.remove('is-collapsed');
      syncHiddenBySticky(wa);
      try {
        sessionStorage.setItem(storageKey, '1');
      } catch (e) {}
      emitWaEvent('chagual:wa_expand', {
        context: wa.dataset.waContext || '',
        path: path,
        threshold: currentThreshold(),
        label: wa.dataset.waLabel || (bubble ? bubble.textContent.trim() : '')
      });
      collapseTimer = window.setTimeout(collapseBubble, 4200);
    }

    function isMobileMenuOpen() {
      return !!document.querySelector('#header [data-mobile-menu][open]');
    }

    function onScroll() {
      computeOverlay();
      syncHiddenByFooter(wa);

      if (syncHiddenBySticky(wa)) {
        collapseBubble();
        return;
      }

      var threshold = currentThreshold();
      var saleRoot = document.querySelector('[data-sale-plp-root]');
      var isSalePlp = wa.dataset.waContext === 'collection' && !!saleRoot;

      var suppressFab = isMobileMenuOpen();

      if (!suppressFab) {
        suppressFab = isSalePlp ? isSaleSupportVisible() : isSaleSupportVisible();
      }
      wa.classList.toggle('is-suppressed', suppressFab);
      syncHiddenBySticky(wa);

      if (suppressFab) {
        collapseBubble();
        return;
      }

      if (!isCompactMobile() && !expandedOnce && window.scrollY >= threshold) {
        expandBubble();
        return;
      }

      if (wa.classList.contains('is-expanded') && window.scrollY > threshold + 24) {
        collapseBubble();
      }
    }

    try {
      expandedOnce = sessionStorage.getItem(storageKey) === '1';
    } catch (e) {
      expandedOnce = false;
    }

    if (expandedOnce) {
      collapseBubble();
    }

    window.addEventListener('scroll', function () {
      var currentScrollY = window.pageYOffset || window.scrollY || 0;
      if (currentScrollY > lastScrollY + 2) scrollDirection = 'down';
      else if (currentScrollY < lastScrollY - 2) scrollDirection = 'up';
      lastScrollY = currentScrollY;
      isScrollSettling = true;
      if (settleTimer) window.clearTimeout(settleTimer);
      settleTimer = window.setTimeout(function () {
        isScrollSettling = false;
        onScroll();
      }, 180);

      if (raf) return;
      document.documentElement.classList.add('chagual-wa-scrolling');
      raf = window.requestAnimationFrame(function () {
        raf = 0;
        onScroll();
        window.setTimeout(function () {
          document.documentElement.classList.remove('chagual-wa-scrolling');
        }, 120);
      });
    }, { passive: true });

    function syncViewportSafety() {
      computeOverlay();
      syncHiddenByFooter(wa);
      syncHiddenBySticky(wa);
    }

    window.addEventListener('resize', syncViewportSafety, { passive: true });
    window.addEventListener('orientationchange', syncViewportSafety, { passive: true });
    wa.addEventListener('click', function () {
      if (syncHiddenBySticky(wa)) return;
      emitWaEvent('chagual:wa_click', {
        context: wa.dataset.waContext || '',
        path: path,
        label: wa.dataset.waLabel || (bubble ? bubble.textContent.trim() : '')
      });
    });

    wa.addEventListener('mouseenter', function () {
      if (syncHiddenBySticky(wa)) return;
      if (window.innerWidth >= 981) {
        wa.classList.add('is-expanded');
        wa.classList.remove('is-collapsed');
        syncHiddenBySticky(wa);
      }
    });
    wa.addEventListener('mouseleave', function () {
      if (window.innerWidth >= 981) collapseBubble();
    });

    computeOverlay();
    syncHiddenByFooter(wa);
    onScroll();
  }

  function initWhatsapp() {
    bindWhatsapp(document.getElementById('chagualWaTab'));
    syncContextualWhatsappLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWhatsapp, { once: true });
  } else {
    initWhatsapp();
  }

  window.addEventListener('load', computeOverlay, { once: true });
  window.addEventListener('pageshow', computeOverlay, { passive: true });
  document.addEventListener('shopify:section:load', initWhatsapp);
})();
